import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  DataService,
  PamlabApiServiceService,
  SnackbarService,
  ScreenSizeService,
  RouteService,
} from '@/shared/services';
import { Subscription } from 'rxjs';
import { CourseInfoExtended } from '../../../../../server/types';

@Component({
  selector: 'courses-recommender-content',
  templateUrl: './courses-recommender-content.component.html',
  styleUrls: ['./courses-recommender-content.component.css'],
  standalone: false,
})
export class CoursesRecommenderContentComponent implements OnInit, OnDestroy {
  public dataPending!: boolean;
  private subscription: Subscription = new Subscription();
  displayedColumns: string[] = [
    'rank',
    'course_code',
    'course_name',
    'pass_rate',
  ];

  public coursesRecommendedData: CourseInfoExtended[] = [];

  mobileView: boolean = false;
  webView: boolean = true;

  currentIndex: number = 0;
  currentCourseRecommender: any;

  constructor(
    private dataService: DataService,
    private snackbarService: SnackbarService,
    private apiService: PamlabApiServiceService,
    private screenSizeService: ScreenSizeService,
    private routeService: RouteService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.dataService.getData().subscribe({
        next: (dataStream) => {
          if (dataStream.data) {
            this.coursesRecommendedData =
              dataStream.data as CourseInfoExtended[];
            this.currentCourseRecommender =
              this.coursesRecommendedData[this.currentIndex];
          }

          dataStream.error &&
            this.snackbarService.open(dataStream.error.message, 'error');
        },
      }),
    );

    this.subscription.add(
      this.dataService.getPendingData().subscribe((pending) => {
        this.dataPending = pending;
      }),
    );

    this.subscription.add(
      this.screenSizeService.screenView$.subscribe((view) => {
        this.mobileView = view === 'mobile';
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  nextItem() {
    this.currentIndex = this.currentIndex + 1;
    this.currentCourseRecommender =
      this.coursesRecommendedData[this.currentIndex];
  }

  prevItem() {
    this.currentIndex = this.currentIndex - 1;
    this.currentCourseRecommender =
      this.coursesRecommendedData[this.currentIndex];
  }

  navigateToGlossaryOfTerms(termValue: string) {
    this.routeService.navigateNewTab('/glossary-of-terms', {
      term_value: termValue,
    });
  }
}
